"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = require("lodash");
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var HeaderNav = props => {
  var apiUrl = '/apicalls/navheader/';
  if (props.params.testApp == 'scTestGroove') {
    apiUrl = "/apicalls/navheader/?app=".concat(props.params.appName);
    if (!(0, _lodash.isEmpty)(props.selectedSiteNav)) apiUrl = "".concat(apiUrl, "&sitemodule=").concat(props.selectedSiteNav.toLowerCase());
  } else if (!(0, _lodash.isEmpty)(props.selectedSiteNav)) {
    apiUrl = "".concat(apiUrl, "?sitemodule=").concat(props.selectedSiteNav.toLowerCase());
  }
  var [error, setError] = (0, _react.useState)(null);
  var [isLoaded, setIsLoaded] = (0, _react.useState)(false);
  var [items, setItems] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    fetch(apiUrl).then(res => res.json()).then(result => {
      setIsLoaded(true);
      setItems(result);
    }, error => {
      setIsLoaded(false);
      setError(error);
    });
  }, []);
  if (isLoaded && items.length !== 0) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.NavbarConsumer, {
      tree: Object.assign({}, items)
    }));
  } else return null;
};
var _default = exports.default = HeaderNav;